// @flow

import { beginRequest, completeRequest } from "@store/utils";
import * as actions from "@modules/reporting/constants/actions";
import { cloneObject } from "@utils/object";
import type { ProvidersReportState } from "./types";
import initialState from "./state";

const startRequest = beginRequest(["requestsInProgress"]);
const finishRequest = completeRequest(["requestsInProgress"]);

export const setLoading = (state: ProvidersReportState) => () => startRequest(state);
export const setLoaded = (state: ProvidersReportState) => () => finishRequest(state);

export const onGetProvidersReportSuccess = (state: ProvidersReportState) => ({
  payload,
}: Object) => {
  return {
    ...state,
    ...finishRequest(state),
    list: payload,
  };
};

export const onGetCoverageDataSuccess = (state: ProvidersReportState) => ({ payload }: Object) => {
  return {
    ...state,
    ...finishRequest(state),
    coverage: payload,
  };
};

export const onGetCoverageChartDataSuccess = (state: ProvidersReportState) => ({
  payload,
}: Object) => {
  return {
    ...state,
    ...finishRequest(state),
    coverageChart: payload,
  };
};

export default (
  state: ProvidersReportState = initialState,
  action: Object,
): ProvidersReportState => {
  const act = {
    [actions.GetProvidersReport]: setLoading,
    [actions.GetProvidersReportSuccess]: onGetProvidersReportSuccess,
    [actions.GetProvidersReportError]: setLoaded,
    [actions.ExportProvidersReport]: setLoading,
    [actions.ExportProvidersReportSuccess]: setLoaded,
    [actions.ExportProvidersReportError]: setLoaded,

    [actions.GetCoverageData]: setLoading,
    [actions.GetCoverageDataSuccess]: onGetCoverageDataSuccess,
    [actions.GetCoverageDataError]: setLoaded,
    [actions.ExportCoverageData]: setLoading,
    [actions.ExportCoverageDataSuccess]: setLoaded,
    [actions.ExportCoverageDataError]: setLoaded,

    [actions.GetCoverageChartData]: setLoading,
    [actions.GetCoverageChartDataSuccess]: onGetCoverageChartDataSuccess,
    [actions.GetCoverageChartDataError]: setLoaded,
  };

  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
